import { ADMINUSER } from './types';


export function setUser(user) {
    return {
        type: ADMINUSER,
        user
    };
}